<template>
  <BaseCard flat>
    <BaseCardBody>
      <h3 class="text-sm">Facebook: {{ type }}</h3>
      <h5 class="text-xs font-normal text-gray-500">Subtype: {{ subType }}</h5>
      <p class="text-xs text-gray-500 mt-1">Account: {{ account }}</p>
    </BaseCardBody>
  </BaseCard>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    facebookAudience: {
      type: Object,
      required: true,
    },
  },
  computed: {
    subType() {
      return (this.facebookAudience.subtype || 'Subtype not available').toLowerCase();
    },
    account() {
      if (!this.facebookAudience.account) {
        return 'Account not available';
      }

      return this.facebookAudience.account?.name || 'Not available';
    },
  },
};
</script>
